import type { AssetRiskTagProps } from "./asset-risk-tag.type";

import { useAssetRisksReferential } from "@/modules/asset/asset-risk";
import { RiskTag } from "@/modules/risk-tag";

export const AssetRiskTag = ({ asset, size }: AssetRiskTagProps) => {
  const { getRiskLevel, noRisk } = useAssetRisksReferential();
  const risk = getRiskLevel(asset?.risk_level) ?? noRisk;

  if (!risk) return null;

  return <RiskTag risk={risk} size={size} />;
};
